/**
 * THE MARK AND THE WORDMARK, shared by the two screens a person meets
 * before they are anybody: the front door and sign-in.
 *
 * Shared because they are the SAME moment from the visitor's side --
 * arrive, say who you are, get in -- and the seam between them being
 * visible was the bug: the apex was a branded card and sign-in was a
 * navy glass panel with an h1.
 *
 * The MARK, not public/brand/polywog-lockup.jpg: that is a JPEG on
 * black and carries its own background into a light page. favicon.svg
 * is transparent and already the favicon, so the wordmark is text
 * beside it and the whole assembly themes and scales.
 */
import { Typography } from 'antd';

import { BRAND } from '../../../theme';

export function Brand() {
  return (
    <div style={{ textAlign: 'center' }}>
      <img
        src="/favicon.svg"
        alt=""
        width={108}
        height={108}
        style={{ display: 'block', margin: '0 auto 0.75rem' }}
      />
      <Typography.Title
        level={1}
        style={{
          margin: 0,
          fontSize: '1.9rem',
          fontWeight: 500,
          letterSpacing: '-0.015em',
          color: BRAND.teal,
        }}
      >
        polywog
      </Typography.Title>
    </div>
  );
}
